<template>
  <ProjectManagerLayout ref="layoutRef">
    <MainTitle>Запросы на участие в команде</MainTitle>
    <HorizontalFilter>
      <template #default>
        <FilterItem path="/leader/team" text="Новые запросы" />
        <FilterItem path="/leader/team/rejected" text="Отклоненные" />
      </template>
    </HorizontalFilter>
    <LeaderTeamNew
      v-if="ROUTE_NAME_LEADER_TEAM === route.name"
      @update="onUpdate"
    />
    <LeaderTeamRejected v-if="ROUTE_NAME_LEADER_TEAM_REJECTED === route.name" />
  </ProjectManagerLayout>
</template>

<script setup>
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import MainTitle from '@/components/titles/MainTitle.vue';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter.vue';
  import FilterItem from '@/components/filter/components/FilterItem.vue';
  import LeaderTeamNew from '@/views/leader/team/pages/LeaderTeamNew.vue';
  import LeaderTeamRejected from '@/views/leader/team/pages/LeaderTeamRejected.vue';
  import {
    ROUTE_NAME_LEADER_TEAM,
    ROUTE_NAME_LEADER_TEAM_REJECTED,
  } from '@/constants/route';
  import { useRoute } from 'vue-router';
  import { ref } from 'vue';

  const route = useRoute();
  const layoutRef = ref(null);

  const onUpdate = async () => {
    await layoutRef.value.updateCounters();
  };
</script>

<style lang="scss" scoped>
  .horizontal-filter {
    margin-bottom: 30px;
  }
</style>
